import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const ArrowLeftToLineIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.49854V0.498779C0 0.223327 0.223327 0 0.498779 0C0.774231 0 0.997559 0.223327 0.997559 0.498779V7.49854C0.997559 7.77399 0.774231 7.99731 0.498779 7.99731C0.223327 7.99731 0 7.77399 0 7.49854ZM5.146 0.645996C5.34073 0.451263 5.65653 0.451344 5.85132 0.645996C6.04609 0.84077 6.04609 1.15654 5.85132 1.35132L3.70239 3.50024H9.49878C9.77423 3.50024 9.99756 3.72357 9.99756 3.99902C9.99743 4.27436 9.77415 4.4978 9.49878 4.4978H3.70312L5.85132 6.646C6.04609 6.84077 6.04609 7.15654 5.85132 7.35132C5.65654 7.54609 5.34077 7.54609 5.146 7.35132L2.146 4.35132C2.0526 4.25785 2.00031 4.13115 2.00024 3.99902C2.00024 3.86675 2.05246 3.73953 2.146 3.646L5.146 0.645996Z"
        fill={color}
      />
    </svg>
  ),
);

ArrowLeftToLineIcon.displayName = 'ArrowLeftToLineIcon';
